module.exports = __webpack_public_path__ + "static/media/chile@2x.08c2dcf7.jpg";